// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__VgxsD"};